import React from 'react';

import DeepResearchPromo from './DeepResearchPromo';

const DesktopProSubscriberContent = () => (
  <div className="hidden w-[480px] flex-col items-center md:flex">
    <DeepResearchPromo />
  </div>
);

export default DesktopProSubscriberContent;
